import { Component } from '@angular/core';
import { IonicPage, NavController, NavParams, ViewController, App } from 'ionic-angular';
import { BillingPaymentsProvider } from '../../providers/billing-payments/billing-payments';
import { ToastProvider } from '../../providers/toast/toast';
import { PaymentDetailPage } from '../payment-detail/payment-detail';
import { BillingPaymentsPage } from '../billing-payments/billing-payments';
import { TranslateService } from '@ngx-translate/core';

@IonicPage()
@Component({
  selector: 'page-payment-list',
  templateUrl: 'payment-list.html',
})
export class PaymentListPage {

	payments = [];
  showData = false;
  showHead = false;
  title = "Payments";

  constructor(public navCtrl: NavController, 
  	public navParams: NavParams, 
  	private bpProvider: BillingPaymentsProvider,
    private toast: ToastProvider,
    private translate: TranslateService,
    public viewCtrl: ViewController,
    public app: App) {
    let type = this.navParams.get("type");
    this.title = (this.navParams.get("title")?this.navParams.get("title"):"Payments")
    bpProvider.getPayments(type).then(val => {
      if(val.status == "success"){
        this.payments = val.data;
      }else{
        this.toast.presentToast(val.message);
      }
      this.showData = true;
    }).catch(val => {
      this.showData = true;
    });

    if(type == "RETURNED"){
      this.showHead = true;
    }else if(type == "CLEARED"){
      this.showHead = true;
    }
  }

  doRefresh(refresher) {
    this.bpProvider.getPayments(this.navParams.get("type")).then(val => {
      if(val.status == "success"){
        this.payments = val.data;
      }
      else{
        this.toast.presentToast(val.message);
      }
      refresher.complete();
    });
  }

  detailPage(id: number){
    this.app.getRootNav().push(PaymentDetailPage, {
      id
    });
  }

  ionViewDidLoad() {
    console.log('ionViewDidLoad PaymentListPage');
  }

}



// WEBPACK FOOTER //
// ./src/pages/payment-list/payment-list.ts